// extracted by mini-css-extract-plugin
module.exports = {"btnWrapper":"PersonaDeleteModal_btnWrapper__6hSjq"};